var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.21 146.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f343f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66,146.77H13.92a15.38,15.38,0,0,1-7.38-1.58A11.51,11.51,0,0,1,0,134.41a52.07,52.07,0,0,1,2.53-16.29,27.47,27.47,0,0,1,9.84-13.39c8.72-6.57,18.56-10.77,29-13.64a3.6,3.6,0,0,1,3.45.77C54.36,99.3,65,100.64,76.46,97.7a25.68,25.68,0,0,0,10-5.23,5.18,5.18,0,0,1,5-1.28,66.8,66.8,0,0,1,7.7,2.56,106.21,106.21,0,0,1,16,7.75c9.18,5.57,14.85,13.35,16.12,24.15.4,3.43,1.21,6.82.73,10.31a12.38,12.38,0,0,1-9.93,10.45,34.19,34.19,0,0,1-6.63.39H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.41,27C98,16.39,92.51,8.14,82.34,3.5a38.46,38.46,0,0,0-22-3c-13.94,2.09-23.5,9.6-27.76,23.26-2.77,8.91-2.77,18-1.15,27.12,2,11.33,6.62,21.38,15.73,28.82,7.06,5.76,15.18,8.12,24.27,6.44,8.8-1.62,15.36-6.68,20.45-13.76,7-9.68,9.76-20.7,9.93-32.49A57.36,57.36,0,0,0,100.41,27ZM80.22,70.57c-5.35,5.55-12,7.68-19.56,5.42-5.08-1.52-8.86-4.9-11.9-9.09-5.15-7.14-7.9-15.09-8-20.78-.11-10.19,2-12.45,9.09-12.81C54.93,33.05,60,33,65,32A35.22,35.22,0,0,0,76.3,28c2.85-1.67,5.4-1.62,7.83.72a12.62,12.62,0,0,0,1.53,1.2,12.64,12.64,0,0,1,5.63,10.12C91.78,51.73,88.4,62.09,80.22,70.57Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfil);
export default __webpack_public_path__ + "static/media/IconProfil.8c34706ec6659c02eadc5b9630192bbb.svg";
export { ForwardRef as ReactComponent };